import { render, staticRenderFns } from "./MLayout.vue?vue&type=template&id=a1c718ba&scoped=true"
import script from "./MLayout.vue?vue&type=script&lang=js"
export * from "./MLayout.vue?vue&type=script&lang=js"
import style0 from "./MLayout.vue?vue&type=style&index=0&id=a1c718ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c718ba",
  null
  
)

export default component.exports